import React from "react";
import EV54AlarmsCard from "./EV54AlarmsCard";
import styles from "./EV54AlarmsCardList.module.css";
import { useTranslation } from "react-i18next";

const EV54AlarmsCardList = ({ headings, data, fetchingAlarmsData }) => {
  const { t } = useTranslation("truscriptAlarmsTable")

  const headingsObj = {
    description: headings[0],
    occurred: headings[1],
  };

  if (data.length || fetchingAlarmsData) {
    return data.map((dataRow, index) => (
      <div key={index} className={styles.EV54AlarmsCardList__container}>
        <EV54AlarmsCard
          headingsObj={headingsObj}
          dataObj={{
            description: dataRow[0],
            occurred: dataRow[1],
            actions: dataRow[2],
          }}
        />
        {index < data.length - 1 && (
          <hr className={styles.EV54AlarmsCardList__hr} />
        )}
      </div>
    ));
  } else {
    return (
      <div className={styles.EV54AlarmsCardList__noDataFoundMessage}>
        <p>{t("noData")}</p>
      </div>
    );
  }
};

export default EV54AlarmsCardList;
